// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import { pluralizeChecked } from '../../infrastructure/utils/common';

const PartySummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 15px 20px;
  margin: 30px 0 30px 0;
  border: solid 1px rgba(79, 79, 79, 0.2);

  @media (max-width: 768px) {
    display: none;
  }
`;

const PartySummaryItem = styled.div`
  font-size: 18px;
  color: #666666;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
`;

const PartySummary = React.forwardRef(
  (
    {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      membersCount,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      eventsCount,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      draftOrdersCount,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      bachPurchasesCount,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      expensesCount,
    },
    ref
  ) => {
    const onItemClick = key => {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      const el = ref[key]?.current;
      if (!el) return;
      const isCollapsed = el.dataset.collapsed === 'true';
      if (isCollapsed) {
        el.click();
      }
      const yOffset = -100;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      setTimeout(() => {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 150);
    };

    return (
      <PartySummaryContainer>
        <PartySummaryItem onClick={() => onItemClick('membersBlockRef')}>
          {membersCount} {pluralizeChecked(membersCount, 'guest')} invited
        </PartySummaryItem>
        <PartySummaryItem onClick={() => onItemClick('eventsBlockRef')}>
          {eventsCount} itinerary {pluralizeChecked(eventsCount, 'event')}
        </PartySummaryItem>
        <PartySummaryItem onClick={() => onItemClick('ordersBlockRef')}>
          {draftOrdersCount} drafts{' '}
          {pluralizeChecked(draftOrdersCount, 'order')}
        </PartySummaryItem>
        <PartySummaryItem onClick={() => onItemClick('ordersBlockRef')}>
          {bachPurchasesCount} BACH{' '}
          {pluralizeChecked(bachPurchasesCount, 'purchase')}
        </PartySummaryItem>
        <PartySummaryItem onClick={() => onItemClick('expensesBlockRef')}>
          {expensesCount} {pluralizeChecked(expensesCount, 'expense')}
        </PartySummaryItem>
      </PartySummaryContainer>
    );
  }
);

export default React.memo(PartySummary);
